var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('h1',{staticClass:"display-1 text-center"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"lead text-center"},[_vm._v("Seite nicht gefunden")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('b-link',{attrs:{"to":{ name: 'home.index' }}},[_vm._v("Gehe zurück zur Startseite")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e543f76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Errors/404.vue
// module id = null
// module chunks = 